import * as React from 'react'
import { PageDefinition, PageType } from '../pageDefinition'
import { LicensedAgency } from 'contexts/CurrentCustomerContext'
import { ColumnDef } from 'cs-kevlar-react/lib/es/table/base'
import { Table, Box, ContentSection } from 'cs-kevlar-react'
import { useAuth } from 'hooks'
import {
  FilterOptions,
  PaginationOptions,
} from 'cs-kevlar-react/lib/es/table/Table'
import { useAgency } from 'hooks/useAgency'

const AGENCIES_FILTER_OPTIONS: Partial<FilterOptions> = {
  filterable: false,
}

const AGENCIES_PAGINATION_OPTIONS: Partial<PaginationOptions> = {
  hidePaginationBar: true,
  disablePaging: true,
  singularAdjective: 'agency',
  pluralAdjective: 'agencies',
}

const agencyColumns: ColumnDef<LicensedAgency, string>[] = [
  {
    label: 'Name',
    sortable: true,
    sortByDefault: true,
    filterable: false,
    dataProperty: 'name' as keyof LicensedAgency,
  },
  {
    label: 'Agency ID',
    sortable: true,
    sortByDefault: false,
    filterable: false,
    dataProperty: 'uniqueIdentifier' as keyof LicensedAgency,
  },
  {
    label: 'Licenses',
    sortable: true,
    sortByDefault: false,
    filterable: false,
    dataProperty: 'licenseCount' as keyof LicensedAgency,
  },
]

const AgencyManagement: React.FunctionComponent = () => {
  const agency = useAgency()
  const { authorizedAgencies } = useAuth()
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    const loadData = async () => {
      setIsLoading(true)
      await agency.unassistAgency()
      await agency.getAuthorizedAgencies()
      setIsLoading(false)
    }

    loadData()
  }, [])

  return (
    <React.Fragment>
      <Box>
        <ContentSection title="Agencies" disableContentPadding>
          <Table
            filterOptions={AGENCIES_FILTER_OPTIONS}
            paginationOptions={AGENCIES_PAGINATION_OPTIONS}
            data={authorizedAgencies}
            columns={agencyColumns}
            ariaLabel="Agencies for User"
            useDefaultRow
            onRowClicked={(row) => agency.assistAgency(row.licensedAgencyId)}
            isLoading={isLoading}
            uniqueIdentifier="UserAgenciesList"
          />
        </ContentSection>
      </Box>
    </React.Fragment>
  )
}

export const AgencyManagementPage: PageDefinition = {
  routes: () => ['/agencyManagement'],
  type: [PageType.Admin],
  sortOrder: () => 0,
  component: <AgencyManagement />,
  pageTitle: `Agency Management`,
  navLinkText: 'Details',
  canAccess: (user) => {
    return (
      user !== null &&
      user.authorizedLicensedAgencies !== undefined &&
      user.authorizedLicensedAgencies !== null &&
      user.authorizedLicensedAgencies.length > 1
    )
  },
  buildNavLink: (user) => '/agencyManagement',
}
